import { FC } from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import useTranslate from '@/hooks/use-translate'
import { getNf, nf } from '../nfTokens'

const formatFileSize = (bytes: number) =>
  bytes > 1048576
    ? `${(bytes / 1048576).toFixed(1)} Mo`
    : `${Math.round(bytes / 1024)} Ko`

export interface NfFileRowProps {
  name: string
  size: number
  onRemove: () => void
}

export const NfFileRow: FC<NfFileRowProps> = ({
  name,
  size,
  onRemove,
}) => {
  const { t: tUpload } = useTranslate('upload')

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.25}
      sx={(theme) => {
        const t = getNf(theme)
        return {
          p: '9px 11px',
          borderRadius: `${nf.radiusCard}px`,
          border: `1px solid ${t.line}`,
          bgcolor: t.surface,
        }
      }}
    >
      <Box
        sx={(theme) => {
          const t = getNf(theme)
          return {
            width: 28,
            height: 28,
            borderRadius: `${nf.radiusField}px`,
            bgcolor: t.line2,
            color: t.ink3,
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0,
          }
        }}
      >
        <InsertDriveFileOutlinedIcon sx={{ fontSize: 14 }} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={(theme) => ({
            fontSize: 11.5,
            fontWeight: 500,
            color: getNf(theme).ink,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          })}
        >
          {name}
        </Typography>
        <Typography
          sx={(theme) => ({ mt: '3px', fontSize: 10, color: getNf(theme).muted })}
        >
          {formatFileSize(size)}
        </Typography>
      </Box>
      <IconButton
        size="small"
        aria-label={tUpload('wizardRemoveFile')}
        title={tUpload('wizardRemoveFile')}
        onClick={onRemove}
        data-testid="file-input-remove-button"
        sx={(theme) => ({ color: getNf(theme).muted2, flexShrink: 0 })}
      >
        <DeleteOutlineIcon sx={{ fontSize: 15 }} />
      </IconButton>
    </Stack>
  )
}

export default NfFileRow
